import css from "./PrivacyPolicy.module.css";
import Intro from "../../components/intro/Intro";
import Checklist from "../../components/checklist/Checklist";

const PrivacyPolicy = () => {
  return (
    <div className={css.main}>
      <Intro primary="PRIVACY POLICY" />
      <div className="column p01 g1">
        <p>
          This privacy notice for SquidSlippers, LLC ("<strong>we</strong>", "
          <strong>us</strong>," or "<strong>our</strong>"), describes how and
          why we might collect, store, use, and/or share ("
          <strong>process</strong>") your information when you use our services
          ("<strong>Services</strong>
          "), such as when you...
        </p>
        <Checklist
          bullets={[
            <p>
              ...visit our website at www.squidslippers.com.
            </p>,
            <p>
              ...engage with us in other related ways, including any LIVE
              streams, promotional sales, or marketing events.
            </p>,
          ]}
        />
        <h2 style={{ marginTop: "3rem" }}>TABLE OF CONTENTS</h2>
        <Checklist
          bullets={[
            <p>THE INFORMATION WE PROCESS</p>,
            <p>HOW WE PROTECT YOUR INFORMATION</p>,
            <p>HOW WE PROCESS YOUR INFORMATION</p>,
            <p>HOW LONG WE KEEP YOUR INFORMATION</p>,
            <p>WHEN AND WITH WHOM WE SHARE YOUR INFORMATION</p>,
            <p>OUR AFFILIATION WITH THIRD-PARTY WEBSITES</p>,
            <p>UPDATES TO THIS POLICY</p>,
            <p>CONTACTING US ABOUT THIS POLICY</p>,
          ]}
        />
        <h2>1. THE INFORMATION WE PROCESS</h2>
        <p>
          We collect information that you voluntarily provide to us when you
          express an interest in obtaining information about us or our products
          and Serices, when you participate in activities with regards to our
          Services, or otherwise when you contact us.
        </p>
        <h3>PERSONAL INFORMATION</h3>
        <p>
          The personal information that we collect depends on the context of
          your interactions with us and our Services, the choices you make, and
          the products and features you use. The personal information we collect
          may include...
        </p>
        <Checklist
          bullets={[
            <p>...your name.</p>,
            <p>...your phone number.</p>,
            <p>...your email address.</p>,
            <p>...your mailing address.</p>,
          ]}
        />
        <h3>SENSITIVE INFORMATION</h3>
        <p>
          When necessary (e.g. when you make a purchase), with your consent and
          when permitted by law, we process sensitive information that may
          include...
        </p>
        <Checklist
          bullets={[
            <p>
              ...the last 4 digits of your payment card number.
            </p>,
          ]}
        />
        <p>
          We do not log, store, or track payment information, including card
          numbers, expiration dates, CVV codes, billing addresses, etc. Instead,
          we rely on our trusted partner, Stripe, to securely process all
          financial transactions. Stripe adheres to strict security standards
          and processes payments securely.
        </p>
        <h3>DEVICE AND USAGE INFORMATION</h3>
        <p>
          Device and usage informatin is service-related, diagnostic, usage, and
          performance information our servers automatically collect when you
          access or use our Services and which we record in log files. Depending
          on how you interact with us, this information may include...
        </p>
        <Checklist bullets={[<p>...your IP address.</p>]} />
        <h2>2. HOW WE PROTECT YOUR INFORMATION</h2>
        <p>
          We employ exhaustive security measures to protect your personal
          information from unauthorized access, alteration, and deletion. The
          security measures we take to protect your information include...
        </p>
        <Checklist
          bullets={[
            <p>
              ...employing strong encryption algorithms to protect data in
              transit and in storage.
            </p>,
            <p>...conducting regular security audits.</p>,
            <p>
              ...enforcing role-based access to sensitive data.
            </p>,
            <p>
              ...adhering to the Open Web Application Security Project's top 10
              vulnerabilities to address common security risks.
            </p>,
            <p>
              ...complying with the General Data Protection Regulation to
              protect EU citizens' personal data.
            </p>,
          ]}
        />
        <p>
          No technology can be guaranteed to be 100% secure, and there is always
          a risk of unauthorized access. Therefore, we cannot promize or
          guarantee that hackers, cybercriminals, or other unauthorized third
          parties will not be able to defeat our security and improperly access,
          alter, or delete your information. Any and all transmission of
          information (including personal information, sensitive information,
          and payment information) to and from our Services is done at your own
          risk.
        </p>
        <h2>3. HOW WE PROCESS YOUR INFORMATION</h2>
        <p>
          We process your personal information for a variety of reasons,
          depending on how you interact with our Services, including...
        </p>
        <Checklist
          bullets={[
            <p>
              ...to offer customer support and otherwise communicate with
              customers.
            </p>,
            <p>
              ...to deliver and facilitate delivery of our Services.
            </p>,
            <p>
              ...to fulfill and manage orders, payments, returns, and exchanges.
            </p>,
            <p>
              ...to send marketing and promotional communications in accordance
              with your marketing preferences.
            </p>,
            <p>
              ...to determine the effectiveness of marketing and promotional
              campaigns.
            </p>,
            <p>
              ...to analyze and optimize usage and performance.
            </p>,
          ]}
        />
        <h2>4. HOW LONG WE KEEP YOUR INFORMATION</h2>
        <p>
          We only keep your personal information for as long as is necessary to
          fulfill the purpose for which the information was required, unless a
          longer retention period is required or permitted by law (such as tax,
          accounting, or other legal requirements).
        </p>
        <p>
          When we have no ongoing legitimate business need to process your
          personal information, we will either delete or anonymize your
          information.
        </p>
        <h2>5. WHEN AND WITH WHOM WE SHARE YOUR INFORMATION</h2>
        <p>
          We have a short list of third-party service providers whom we trust to
          help us deliver our Services. In order for them to perform services on
          our behalf, they require access to the information we process.
        </p>
        <h4>GOOGLE CLOUD PLATFORM</h4>
        <p>
          We rely on Google Cloud Platform to host our website, database, and
          other digital assets. Whenever you willingly provide us with
          information (including personal and sensitive information—but not
          payment information), that information is shared with Google Cloud
          Platform.
        </p>
        <a
          className="link"
          href="https://policies.google.com/privacy?hl=en"
          target="_blank"
          rel="noopener"
        >
          VIEW GOOGLE'S PRIVACY POLICY
        </a>
        <h4>STRIPE</h4>
        <p>
          We rely on Stripe to securely process payments. Whenever you purchase
          an item from our website, your information (including personal
          information, sensitive information, and payment information) is shared
          with Stripe.
        </p>
        <a
          className="link"
          href="https://www.stripe.com/privacy"
          target="_blank"
          rel="noopener"
        >
          VIEW STRIPE'S PRIVACY POLICY
        </a>
        <h4>BUSINESS TRANSFERS</h4>
        <p>
          We may share or transfer your information in connection with, or
          during negotiations of, any merger, sale of company assets, financing,
          or acquisition of all or a portion of our business to another company.
        </p>
        <h2>6. OUR AFFILIATION WITH THIRD-PARTY WEBSITES</h2>
        <p>
          Our Services may link to third-party websites, online services, or
          mobile applications and/or contain advertisements from third parties
          who are not affiliated with us and who may link to other websites,
          services, or applications. The inclusion of a link to any third-party
          website, service, or application does not imply an endorsement by us
          or them.
        </p>
        <p>
          Any data collected by third parties is not covered by this privacy
          policy. We cannot guarantee the safety and privacy of data you provide
          to any third parties, and we do not make any guarantee regarding any
          such third parties, and we will not be liable for any loss or damage
          caused by the use of such third-party websites, services, or
          applications.
        </p>
        <h2>7. UPDATES TO THIS POLICY</h2>
        <p>
          We may update this privacy notice. The updated version will be
          indicated by an updated date at the top of this privacy notice. If we
          make material changes to this privacy notice, we may notify you either
          by prominently posting a notice of such changes or by directly sending
          you a notification when appropriate. We encourage you to review this
          privacy notice frequently to be informed of how we are protecting your
          information.
        </p>
        <h2>8. CONTACTING US ABOUT THIS POLICY</h2>
        <p>
          If you have questions or comments about this notice, please email us
          at <a href="mailto:contact@mantle-xm.com">contact@mantle-xm.com</a>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
